import './Styles.scss'

const loadDiscussionScript = () => {
    let scriptTag = document.createElement('script')
    scriptTag.setAttribute('src', 'https://d21-a.sdn.cz/d_21/sl/3/loader.js')
    scriptTag.setAttribute('defer', 'defer')
    scriptTag.setAttribute('onload', 'window.common.onloadDiscussionScript()')
    document.body.appendChild(scriptTag)
}

export const onloadDiscussionScript = () => {
    // Discussion
    const discussion = document.getElementById('discussion')

    if (discussion) {
        window.SZN.DiscussionLoader.load(['embedded']).then(() => {
            const instance = SZN.Discussion.create(
                discussion.dataset.serviceName,
                'discussion',
                {
                    linksInNewTab: true
                }
            )

            instance.loadDiscussion(
                discussion.dataset.canonicalString,
                {
                    title: discussion.dataset.postTitle,
                    url:   discussion.dataset.discussionUrl
                }
            )
        })
    }

    // Comments count
    const commentsCount = document.querySelectorAll('[data-comments-count]')

    if (commentsCount) {
        commentsCount.forEach((item) => {
            window.SZN.DiscussionLoader.load(['commentCount']).then(() => {
                window.SZN.Discussion.discussionFetchCommentCount(item.dataset.commentsCount)
                    .then(result => {
                        item.innerHTML = result[item.dataset.commentsCount].commentCount
                    })
            })
        })
    }
}

const initCommentsCount = () => {
    if (window.scrollY > 150) {
        window.removeEventListener('scroll', initCommentsCount)

        loadDiscussionScript()
    }
}

document.addEventListener('DOMContentLoaded', function () {
    // Discussion
    const discussion = document.getElementById('discussion')

    if (discussion) {
        loadDiscussionScript()
    }

    // Comments count
    const commentsCount = document.querySelector('[data-comments-count]')

    if (commentsCount) {
        // Lazy load after 100px scroll
        window.addEventListener('scroll', initCommentsCount)

        initCommentsCount()
    }
})